import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/constants";

export default function FAQ() {
  return (
    <section id="faq" className="py-20 md:py-28 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-[0.2em] text-[#3B6FBF] font-bold mb-4">
            FAQ
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05] text-slate-900" data-testid="faq-title">
            Questions, answered.
          </h2>
          <p className="mt-5 text-slate-600 max-w-xl mx-auto">
            Can't find what you need? Our support team replies in under 2 minutes — every day, all day.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="rounded-2xl border border-slate-200 bg-white px-6 data-[state=open]:border-[#3B6FBF]/40 data-[state=open]:bg-slate-50 transition-all"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display font-bold text-left text-base sm:text-lg hover:no-underline py-5 text-slate-900">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
